// 德语(German)
export default {
  coinSpecialOffer: "HT Münze Auffüllaktion",
  buySomeAndGetExtra: "Kaufe was, erhalte was extra!",
  balance: "Bilanz",
  coins: "{number} Münzen",
  coin: "{number} Münze",
  extraCoins: "{number} extra Münzen",
  continue: "Fortsetzen",
  byToppingUpYouAgree: "Durch Auffüllen stimmst du der Vereinbarung zu",
  topUpAgreement: "[Auffüllvereinbarung]",
  htCoin: "HT Münze",
  scanCodeToLog: "Code scannen zum Anmelden",
  bindYourHelloTalkAccount:
    "Nutze die HelloTalk App, um den Code zu scannen und dich einzuloggen. Verbinde deinen HelloTalk Account und fülle auf.",
  itemSelection: "Artikelauswahl",
  paymentAmount: "Betrag",
  topUpSuccessful: "Auffüllen erfolgreich👏",
  totalCoinsNumber:
    "Du hast {numberone} erfolgreich hinzugefügt und {numbertwo} extra Münzen erhalten, insgesamt also {numberall} Münzen.",
  ok: "OK",
  copyLinkToPay:
    "Bitte kopiere den Link und öffne ihn mit der HelloTalk-App, um die Zahlung abzuschließen.",
  paymentFailed: "Zahlung fehlgeschlagen",
  creditCardPay: "Mit PayPal oder Kreditkarte zahlen",
  creditCard: "Kreditkarte",
};
